"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Chrome as Google, Youtube, MapPin, Phone, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const quickLinks = [{
  label: "Ana Sayfa",
  path: "/HomePage"
}, {
  label: "Tedavilerimiz",
  path: "/TreatmentsPage"
}, {
  label: "Değişim Galerisi",
  path: "/TransformationGalleryPage"
}, {
  label: "Hakkımızda",
  path: "/AboutUsPage"
}, {
  label: "İletişim",
  path: "/ContactPage"
}];
const socialLinks = [{
  icon: Facebook,
  path: "https://www.facebook.com/dishekimiaysegulinneci?locale=tr_TR",
  label: "Facebook"
}, {
  icon: Instagram,
  path: "https://www.instagram.com/dishekimi_aysegulinneci/",
  label: "Instagram"
}, {
  icon: Google,
  path: "https://share.google/cVWmUJq79qBegyxhF",
  label: "Google"
}, {
  icon: Youtube,
  path: "https://www.youtube.com/channel/UCDPAN-oHd2_EaXAvgRmtBhA",
  label: "YouTube"
}];
export default function CorporateFooter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const address = "Tacettin Veli, Lalezade Cd. Kartal İş Merkezi Bina No:45 Kat:2 No:6, 38050 Melikgazi/Kayseri";
  const phone = "+90 553 552 32 34";
  const email = "dt.aysegulinneci@gmail.com";
  const currentYear = new Date().getFullYear();
  return <section data-section-id="155652" id="alt-bilgi" className="bg-background text-foreground relative font-sans pt-16 pb-8 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-primary/30" />

      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="#" className="inline-block w-fit">
              <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/aysss-01-1.png" alt="Ayşegül İnneci Uzun Logo" className="object-contain !w-[300px] !h-[120px]" />
            </Link>
            <div className="flex flex-col gap-4 text-sm text-muted-foreground mt-2">
              <div className="flex items-start gap-3 group">
                <MapPin className="size-4 shrink-0 mt-0.5 text-primary transition-colors group-hover:text-foreground" />
                <span className="leading-relaxed">{address}</span>
              </div>
              <div className="flex items-center gap-3 group">
                <Phone className="size-4 shrink-0 text-primary transition-colors group-hover:text-foreground" />
                <span>{phone}</span>
              </div>
              <div className="flex items-center gap-3 group">
                <Mail className="size-4 shrink-0 text-primary transition-colors group-hover:text-foreground" />
                <span>{email}</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 md:pl-8">
            <h3 className="text-lg font-serif font-medium tracking-wider text-foreground">
              Hızlı Menü
            </h3>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-2 group">
                    <span className="w-1 h-1 rounded-full bg-primary opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-serif font-medium tracking-wider text-foreground">
              Sosyal Medya
            </h3>
            <p className="text-sm text-muted-foreground mb-2">
              Estetik gülüş tasarımlarımız ve güncel vaka paylaşımlarımız için bizi sosyal medyada takip edin.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => <Link key={i} data-index={i} to={social.path} className="bg-secondary hover:bg-primary hover:text-primary-foreground text-primary p-2.5 rounded-sm transition-all duration-300 hover:-translate-y-1" aria-label={social.label}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60">
          <p>© 2026&nbsp;Kayseri Diş Kliniği Ayşegül İnneci Uzun. Tüm hakları saklıdır.<br />Powered by <a href="https://www.kentmedia.com.tr" target="_blank" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:5xv05i" data-ast-start="4917" data-ast-end="5088">Kentmedia</a> </p>
          <p className="tracking-widest uppercase font-sans">
            Estetik ve Lüksün Buluşma Noktası
          </p>
        </div>
      </div>
    </section>;
}